import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MessageService } from 'primeng/api';
import { Cooeperative } from 'src/app/shared/models/cooperative';
import { AuthService } from 'src/app/shared/service/auth/auth.service';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';

@Component({
  selector: 'app-update-cooperative',
  templateUrl: './update-cooperative.component.html',
  styleUrl: './update-cooperative.component.scss'
})

export class UpdateCooperativeComponent {
  item: Cooeperative = new Cooeperative();
  departementItems: any;
  items: any = [];
  categorieProduitItems: any;
  uniteItems: any;
  user_reference: any;
  etatProduitItems: any;
  varieteItems: any;
  photoPreview: string | ArrayBuffer | null = null;
  visible: boolean = false;
  adminItems: any;

  position: string = 'center';
  constructor(
    private modalService: NgbModal,
    private messageService: MessageService,
    private authService: AuthService,
    private fecthDataService: FecthDataService,
    private ngxService: NgxUiLoaderService,
    private localStorage: LocalStorageService,
    private paramService: ParameterService,
    private ngxservice: NgxUiLoaderService

  ) { }



  ngOnInit() {
    this.user_reference = this.localStorage.getUsers();
    console.log("this.user_reference", this.user_reference);
    this.items = this.localStorage.getCooperative();
    this.item = this.localStorage.getCooperative();
    console.log("this.item", this.item);

    this.getAdministrateur();

  }



  close() {

    this.modalService.dismissAll();
  }

  updateCooperative() {
    // if (!this.item.canSave()) {
    //   this.messageService.add({ severity: 'info', summary: "Ikena Cooperative", detail: this.item.getErrorMessage() });
    //   return;
    // }
    // else {
    this.ngxservice.start();
    this.item.superadmin_id =this.user_reference.data.reference;
    this.item.cooperative_id =this.items.reference;
    this.paramService.editCooperative(this.item).subscribe(
      (response: any) => {
        this.ngxservice.stop();
        this.modalService.dismissAll();
        this.messageService.add({
          severity: 'success',
          summary: "Ikena Cooperative",
          detail: response.message,
        });
        this.fecthDataService.notifySeriviceCreated();
      },
      (error: any) => {
        this.ngxservice.stop();
        this.messageService.add({
          severity: 'error',
          summary: "Ikena Cooperative",
          detail: error,
        });
      }
    );
    ///}
  }
  getAdministrateur(){
    this.authService.getAdministrateur(this.user_reference?.data?.reference).subscribe(
      (response:any)=>{
        this.adminItems = response.data;
        console.log('la reponse du  webservice',this.adminItems);

      },
      (error:any)=>{
        console.log("une erreur est survenu",error);

      }
    )
  }
}
